import { calendarioAvaliacaoFixture } from './calendario-avaliacao/calendario-avaliacao.fixture';
import { FixtureCalendarioAvaliacao } from './calendario-avaliacao/calendario-avaliacao.types';
import { configFixture } from './configs/config.fixture';
import { Configs } from './configs/config.types';
import { cursoComplementarFixture } from './curso-complementar/curso-complementar.fixture';
import { FixtureCursoComplementar } from './curso-complementar/curso-complementar.types';
import { Factory, Fixture } from './fixture.types';
import { trabalhoFixture } from './trabalhos/trabalho.fixture';
import { FixtureTrabalho } from './trabalhos/trabalho.types';
import { turmaSelecionadaFixture } from './turmas/turma-selecionada/turma-selecionada.fixture';
import { FixtureTurmaSelecionada } from './turmas/turma-selecionada/turma-selecionada.types';
import { turmaAtualFixture } from './turmas/turmas-atuais/turma-atual.fixture';
import { FixtureTurmaAtual } from './turmas/turmas-atuais/turma-atual.types';
import { turmaCursadaFixture } from './turmas/turmas-cursadas/turma-cursada.fixture';
import { FixtureTurmaCursada } from './turmas/turmas-cursadas/turma-cursada.types';
import { usuarioFixture } from './usuarios/usuario.fixture';
import { FixtureUsuario } from './usuarios/usuario.types';

export const fixtureFactory: Factory = () => {
  const configs: Fixture<Configs> = configFixture;
  const usuario: FixtureUsuario = usuarioFixture;
  const trabalho: FixtureTrabalho = trabalhoFixture;
  const cursoComplementar: FixtureCursoComplementar = cursoComplementarFixture;
  const calendarioAvaliacao: FixtureCalendarioAvaliacao = calendarioAvaliacaoFixture;
  const turmaCursada: FixtureTurmaCursada = turmaCursadaFixture;
  const turmaSelecionada: FixtureTurmaSelecionada = turmaSelecionadaFixture;
  const turmaAtual: FixtureTurmaAtual = turmaAtualFixture;

  return {
    configs,
    usuario,
    trabalho,
    calendarioAvaliacao,
    cursoComplementar,
    turmaCursada,
    turmaSelecionada,
    turmaAtual,
  };
};
